export default __webpack_public_path__ + "static/media/DayScheduler.8aded24a.png";